import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { GoogleService } from '../../../../shared/Google.service';
import { Book } from '../../../../shared/models/book';
import { EBEpouchdbService } from '../../../../EBE/EBEpouchdb.service';
import { IS_ElectronService } from '../../../../shared/IS_Electron.service'
import * as _ from 'lodash';
@Component({
  selector: 'app-mediavideocommon',
  templateUrl: './mediavideocommon.component.html',
  styleUrls: ['./mediavideocommon.component.css']
})
export class MediavideocommonComponent implements OnInit {

  @Input() bookObj;
  @Input() updateData: any;
  @Output() onSelectGvideo = new EventEmitter<string>();
  googleVideoData;
  imageDetails;
  driveFolderData;
  nextToken;
  prevToken;
  selectedGalleryVideo = false;
  selectedCloudVideo = false;
  selectedWebVideo = false;
  webVideoUrl;
  showVideoBackHeader = false;
  galleryVideoUrl = '';
  cloudimageUrl = '';
  videoUrl;
  isShowUpload = false;
  videoUpdated = false;
  driveCloudData;
  public showallimageinmedia;
  constructor(private http: HttpClient, private GoogleService: GoogleService, private pouchService: EBEpouchdbService, private ele: ElementRef, private ElectronService: IS_ElectronService) { }
  ngOnInit() {
    if (this.updateData) {
      this.intializeData(this.updateData);
    }
  }
  intializeData(turl) {
    this.galleryVideoUrl = turl;
  }
  readImageUrl(fileInput) {
    this.isShowUpload = true;
    this.videoUpdated = false;
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'block';
    this.imageDetails = fileInput;
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();
      reader.onload = ((e) => {
        this.videoUrl = e.target['result'];
        this.applyVideo();
      });
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }
  applyVideo() {
    this.isShowUpload = false;
    if (this.ElectronService.IS_ELECTRON) {
      this.ElectronService.insertFileintoMediaFolder(this.imageDetails.target.files[0], this);
    }
    else {
      if (localStorage.currentDriveMediaId)
        this.GoogleService.insertFileintofloder(this.imageDetails.target.files[0], this.imageDetails.target.files, localStorage.currentDriveMediaId, false, this);

    }

    //}
  }


  imageAddedIntoDrive(file) {
    this.videoUpdated = true;
    let vObj: any = {};
    vObj.thumb = file.thumbnailLink;
    vObj.type = 'MyGallery';
    if (this.ElectronService.IS_ELECTRON) {
      this.videoUpdated = false;
      this.videoUrl = file;
      vObj.vUrl = file;
    }
    else {
      this.videoUrl = file.iconLink;
      vObj.vUrl = file.webContentLink;
      if (this.videoUrl != undefined) {
        this.videoUrl = this.videoUrl.replace(/16/g, 128);
      }
    }
    this.onSelectGvideo.emit(vObj);
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';

  }

  searchMediaImgOnEnter(event, keyword, status) {
    if (event.keyCode == 13) {
      this.searchMediaImages(keyword, status)
    }
  }


  ApplyDriveVideo(vUrl, thumb) {
    this.cloudimageUrl = thumb;
    this.selectedCloudVideo = false;
    let vObj: any = {};
    vObj.vUrl = vUrl;
    vObj.thumb = thumb;
    vObj.type = 'Cloud';
    this.webVideoUrl = '';
    this.galleryVideoUrl = '';
    this.onSelectGvideo.emit(vObj);
  }
  retrieveGdata() {
    //  this.GoogleService.Getvideogoogledrive(this);
  }

  loadNext
  searchMediaImages(keyword, status) {


    if (status == 'prev') {
      this.http.get("https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=5&pageToken=" + this.prevToken + "&q=" + keyword + "&key=AIzaSyAsVZZNEFil3tjrDRAntIvR_1kWTHxTUWo&type=video")
        .subscribe(data => {
          this.googleVideoData = data;
          if (this.googleVideoData.nextPageToken) {
            this.nextToken = this.googleVideoData.nextPageToken;
          }
          if (this.googleVideoData.prevPageToken) {
            this.prevToken = this.googleVideoData.prevPageToken;
          }
          this.googleVideoData = this.googleVideoData.items;
        })
      this.loadNext--;
      if (this.loadNext < 1) {
        this.loadNext = 1;
      }
    } else if (status == 'next') {
      this.http.get("https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=5&pageToken=" + this.nextToken + "&q=" + keyword + "&key=AIzaSyAsVZZNEFil3tjrDRAntIvR_1kWTHxTUWo&type=video")
        .subscribe(data => {
          this.googleVideoData = data;
          if (this.googleVideoData.nextPageToken) {
            this.nextToken = this.googleVideoData.nextPageToken;
          }
          if (this.googleVideoData.prevPageToken) {
            this.prevToken = this.googleVideoData.prevPageToken;
          }
          this.googleVideoData = this.googleVideoData.items;
        })
      this.loadNext++;
    } else if (status == 'search') {
      this.googleVideoData = [];
      this.loadNext = 1;
      this.http.get("https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=5&q=" + keyword + "&key=AIzaSyAsVZZNEFil3tjrDRAntIvR_1kWTHxTUWo&type=video")
        .subscribe(data => {
          this.googleVideoData = data;
          if (this.googleVideoData.nextPageToken) {
            this.nextToken = this.googleVideoData.nextPageToken;
          }
          if (this.googleVideoData.prevPageToken) {
            this.prevToken = this.googleVideoData.prevPageToken;
          }
          this.googleVideoData = this.googleVideoData.items;
        })
    }
  }
  applywebVideo(vWeburl, vThumbs) {
    // console.log("https://www.youtube.com/watch?v=9s9FP0Cu8JY" + vWeburl);
    this.webVideoUrl = vThumbs;
    this.selectedWebVideo = false;
    let vObj: any = {};
    vObj.vUrl = vWeburl;
    vObj.thumb = vThumbs;
    vObj.type = 'Web';
    this.galleryVideoUrl = '';
    this.cloudimageUrl = '';
    this.onSelectGvideo.emit(vObj);
  }

  retrieveFolderVData() {
    this.showVideoBackHeader = true;
    this.selectedGalleryVideo = !this.selectedGalleryVideo;
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'block';
    if (this.ElectronService.IS_ELECTRON) {
      this.ElectronService.retrieveAllFilesInFolder(this, 'video');
    }
    else {
      this.GoogleService.retrieveAllFilesInFolder('', this, 'video');
    }

  }

  getAllCloudFloderData(data) {
    this.driveFolderData = data;
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
  }


  retrieveCloudVData() {
    this.showVideoBackHeader = true;
    this.selectedCloudVideo = !this.selectedCloudVideo;
    this.GoogleService.GetGoogleDriveCloudData(this, 'video');
  }
  getAllVideoData(data) {
    this.driveCloudData = data;
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
  }

  // getAllFolderData(data) {
  //   this.driveCloudData = data;
  //   this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
  // }

  retrieveWebVData() {
    this.showVideoBackHeader = true;
    this.selectedWebVideo = !this.selectedWebVideo;
  }
  backToinitialState() {
    this.showVideoBackHeader = !this.showVideoBackHeader;
    this.selectedGalleryVideo = false;
    this.selectedCloudVideo = false;
    this.selectedWebVideo = false;
  }
  ApplyFolderDriveVideo(vUrl, thumb) {
    this.galleryVideoUrl = thumb;
    let vObj: any = {};
    vObj.vUrl = vUrl;
    vObj.thumb = thumb;
    vObj.type = 'MyGallery';
    this.selectedGalleryVideo = false;
    this.webVideoUrl = '';
    this.cloudimageUrl = '';
    this.onSelectGvideo.emit(vObj);
  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/mediavideocommon/mediavideocommon.component.ts